import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useLoaderData, useNavigate } from 'react-router-dom'
import PageAppBar from 'components/PageAppBar'
import { UserModel } from 'types'
import UserDataGrid from 'components/UserDataGrid'

export default function UsersPage() {
  const users = useLoaderData() as UserModel[]
  const navigate = useNavigate()

  return (
    <PageAppBar pageName="Utilisateurs">
      <Box
        sx={{
          padding: '1rem',
          height: 'calc(100vh - 64px)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
          }}
        >
          <Button variant="contained" onClick={() => navigate('/user')}>
            Créer un compte
          </Button>
        </Box>
        <Box sx={{ flexGrow: 1, width: '100%' }}>
          <UserDataGrid users={users} />
        </Box>
      </Box>
    </PageAppBar>
  )
}
